
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/best-okta-alternatives",
      function () {
        return require("private-next-pages/compare/best-okta-alternatives.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/best-okta-alternatives"])
      });
    }
  